import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardLayoutUI = ({
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Title,
  Subheading,
  Pricing,
  Seats,
  Term,
  Credits,
  Subtext,
  CTAs,
  Features,
  Footer
}) => {
  const isMobile = useIsMobile();
  const gridItemProps = {
    gridColumnStart: columnStart,
    paddingInline: '600',
    gridColumn: `${columnStart} / span 1`,
    // visual borders are handled by the MerchCardColumns component
    // For desktop, we only need showBorderLeft to show line between each column
    showBorderTop: undefined,
    showBorderRight: undefined,
    showBorderBottom: undefined,
    showBorderLeft: columnStart > 1
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Title",
      paddingBlockStart: "800",
      position: "relative",
      showBorderTop: isMobile,
      "data-selenium-id": dataSeleniumId,
      "data-test-id": `${dataTestId}-top`,
      "data-mobile-border": isMobile ? 'top' : undefined
    }, gridItemProps, {
      children: Title
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subheading",
      paddingBlockStart: "200"
    }, gridItemProps, {
      children: Subheading
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Pricing",
      paddingBlockStart: "400"
    }, gridItemProps, {
      children: Pricing
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Seats",
      paddingBlockStart: Seats ? '400' : '0'
    }, gridItemProps, {
      children: Seats
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Term",
      paddingBlockStart: Term ? '400' : '0'
    }, gridItemProps, {
      children: Term
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "CTAs",
      paddingBlockStart: "600"
    }, gridItemProps, {
      children: CTAs
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Credits",
      paddingBlockStart: Credits ? '600' : '0'
    }, gridItemProps, {
      children: Credits
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subtext"
    }, gridItemProps, {
      children: Subtext
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Features",
      paddingBlockStart: "600"
    }, gridItemProps, {
      children: Features
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Footer",
      paddingBlockStart: "400",
      paddingBlockEnd: "600",
      showBorderBottom: isMobile,
      "data-test-id": `${dataTestId}-bottom`,
      "data-selenium-id": `${dataSeleniumId}-bottom`,
      "data-mobile-border": isMobile ? 'bottom' : undefined
    }, gridItemProps, {
      children: Footer
    }))]
  });
};